var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "audio-player" }, [
    _c(
      "button",
      {
        staticClass: "audio-player__btn",
        class: { "audio-player__btn--playing": _vm.isPlaying },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.togglePlayer.apply(null, arguments)
          },
        },
      },
      [
        _vm.isPlaying
          ? _c(
              "svg",
              {
                attrs: {
                  width: "15",
                  height: "18",
                  viewBox: "0 0 15 18",
                  fill: "white",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("rect", { attrs: { x: "0", width: "5", height: "18" } }),
                _vm._v(" "),
                _c("rect", { attrs: { x: "10", width: "5", height: "18" } }),
              ]
            )
          : _c(
              "svg",
              {
                staticStyle: { "margin-left": "5px" },
                attrs: {
                  width: "15",
                  height: "18",
                  viewBox: "0 0 15 18",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M13.1347 9L1 16.7066L1 1.29343L13.1347 9Z",
                    fill: "white",
                    stroke: "white",
                    "stroke-width": "2",
                  },
                }),
              ]
            ),
      ]
    ),
    _vm._v(" "),
    _c(
      "audio",
      {
        ref: "audio",
        staticClass: "audio-player__audio",
        on: { ended: _vm.onEnd },
      },
      [_c("source", { attrs: { src: _vm.audioUrl, type: "audio/mpeg" } })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }